class AuthCheckout {
    constructor() {
        this._init()
    }
    _init() {
        this.els = document.querySelectorAll('[data-auth-checkout]')
        if (this.els.length === 0) {
            return
        }

        this.els.forEach((el) => {
            el.authFill = new AuthFill(el, this)
        })
    }
}

class AuthFill {
    constructor(el, manager) {
        this._init(el, manager)
    }
    _init(el, manager) {
        this.el = el
        if (!this.el) {
            return
        }
        this.manager = manager
        this.id = this.el.getAttribute('data-auth-checkout')
        this.toFill = document.querySelector('[data-auth-fill="' + this.id + '"]')
        if (!this.toFill) {
            return
        }
        this.link = document.querySelector('[data-auth-link="' + this.id + '"]')
        this.extraLinks = document.querySelectorAll('[data-auth-link-extra="' + this.id + '"]')
        this.defaultLink = this.link.href

        this.dataKeys = ['first-name', 'last-name', 'address', 'postal-code', 'city', 'country', 'contact', 'nif']
        this.el.addEventListener('change', () => this.onSelectChange())
        this.onSelectChange()
        // window.addEventListener('load', () => this.onSelectChange())
    }
    onSelectChange() {
        const el = this.el.options[this.el.selectedIndex]
        if (!el) {
            throw "none found"
        }
        this.link.href = this.defaultLink.replace(':id', el.value)

        this.extraLinks.forEach(elLink => {
            let url = new URL(elLink.href)
            let search = new URLSearchParams(url.search)
            search.set('billing', el.value)
            url.search = search.toString()
            elLink.href = url.toString()
        });

        this.dataKeys.forEach(key => {
            let attribute = el.getAttribute('data-' + key)
            let fill = this.toFill.querySelector('[data-' + key + ']')
            if(!fill) {
                return
            }
            fill.setAttribute('value', attribute)
            fill.setAttribute('title', attribute)
            if(fill.tagName === "SELECT") {
                if(fill.hasAttribute('data-find-option')) {
                    fill.findOption.selectChild(attribute)
                }
            }

        })
    }
}

export default AuthCheckout